import React from "react";
import SideNav from "../components/nav/SideNav";
import TopNav from '../components/nav/TopNav'
import { Box } from '@chakra-ui/react'
type Props = { children: React.ReactNode }

const DashboardLayout: React.FC<Props> = ({ children }) => {
  return (
    <React.Fragment>
      <SideNav display={{ base: "none", md: "block" }}/>

      <Box ml={{ md: '14rem', lg: '15rem' }}>
        <TopNav />

        <Box 
          px={['1rem', '1rem', '1rem', '2rem']}
          mb='5rem'
        >
          {children}
        </Box>
      </Box>
    </React.Fragment>
  )
}

export default DashboardLayout